var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfSupplyMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 185,
    viewBox: "0 0 412 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0205 120.137L66.8756 27.3288L67.9371 22.6818L178.069 48.307L260.07 62.5137L296.56 112.793L285.149 110.312L332.785 120.668V176.566L261 181.213L194.39 178.956L122.074 181.213L102.569 178.956L97.3941 177.23H77.7561H70.8563L42.7261 174.309V155.853L41.0012 153.596V151.87L42.7261 150.675V139.124H39.807V120.137H37.0205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1406 29.4532L110.265 105.931L192.752 115.381V112.858L111.459 102.213L68.4675 26.3994L67.1406 29.4532Z",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.591 102.213L110.663 105.93",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.887 113.632L260.734 62.5139L68.2021 24.4077L37.1528 120.004H40.8681L69.529 33.5691",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M119.287 124.651L192.752 130.615L193.415 176.982L119.287 178.956L98.588 176.699H93.9438V127.44H98.588L119.287 124.651Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.315 120.668L260.07 105.798L193.414 112.731V117.378V177.126",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8682 120.004V138.991H49.0964V151.339H40.8682V153.065L42.1951 154.658V163.753V174.043",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1953 172.848L64.089 174.441L69.3966 173.778L93.9441 176.433L97.7921 175.902L120.217 177.628L196.513 176.035L260.071 179.752L332.785 173.645V119.473",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.124 139.522V151.339",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6194 174.442L64.354 80.4381L86.6458 72.2062V121.067L68.202 122.394L68.7327 173.778",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9692 76.4548V121.863",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1538 75.3927V121.863",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6035 120.934V79.1104L86.6457 77.7827",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9693 81.2346L70.856 82.9607L71.3867 121.863",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6782 175.504V127.041L97.7916 127.44L118.093 124.651L192.751 130.615V176.32",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.491 107.656V124.651",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.212 127.44V176.566",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M204.012 129.291H194.738V169.828L204.012 170.358V129.291Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.88 125.979V177.23",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.073 127.966V177.623",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M233.002 171.653V127.44L245.209 127.307V172.184L233.002 171.653Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.208 128.236V177.097",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.191 129.291V177.753",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.071 105.798V179.752",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.738 129.291H204.012V170.358L194.738 170.226",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.817 127.573V171.388L245.475 172.052V127.174L229.817 127.573Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.268 127.44V171.521",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M284.087 169.927V129.83L322.037 133.813V167.67L284.087 169.927Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.22 126.643V170.325L325.752 167.936V131.423L284.22 126.643Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.485 129.431L322.036 133.415L325.752 131.29",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.037 133.813V167.67",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.314 130.494V169.529",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.593 131.688V169.13",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.279 132.751V168.334",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5386 29.5859L110.663 105.798",
    stroke: "#8FA1AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.9883 121.731V82.828L71.519 82.2969L74.969 81.1019V121.731H70.9883Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M81.8687 121.199V79.3759L86.5128 78.1809V121.199H81.8687Z",
    fill: "#B1D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M180.192 134.344L129.106 159.571V163.554L180.192 134.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M321.373 144.169L291.518 159.04V161.43L321.373 144.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M182.978 142.974L131.893 168.201V172.184L182.978 142.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M322.567 148.683L292.712 163.554V165.944L322.567 148.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.736 115.623L260.071 109.383L331.988 123.722",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M87.5747 28.6566L119.42 85.0852L253.436 99.0264L223.408 56.226L87.5747 28.6566Z",
    fill: "#8FA1AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.347 135.576H364.427C365.374 135.447 366.242 135.318 367.11 135.124C401.592 128.85 398.83 103.886 398.83 103.886H401.75C401.671 103.886 404.59 130.079 367.347 135.576Z",
    fill: "#AABDC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.257 176.561L383.15 176.561L383.15 90.0971L389.257 90.0971L389.257 176.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.77 176.561L354.849 176.561L354.849 128.167L358.77 128.167L358.77 176.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.938 121.537L381.002 176.562C381.002 177.135 381.735 177.58 382.378 177.58H389.295C389.938 177.58 390.452 177.135 390.452 176.562V114.981H405.752C406.395 114.981 406.909 114.535 406.909 113.962V110.334C406.909 109.761 406.395 109.315 405.752 109.315H396.559C396.173 109.888 396.945 108.742 396.559 109.315H394.888H390.452V105.241H397.523H399.066H408.194C408.837 105.241 409.352 104.796 409.352 104.223V100.594C409.352 100.021 408.837 99.5757 408.194 99.5757H403.952V97.1567C403.952 96.5838 403.437 96.1382 402.795 96.1382H398.552C397.909 96.1382 397.395 96.5838 397.395 97.1567V99.5757H390.324V90.1545C390.324 89.9635 390.259 89.7725 390.131 89.5816C389.809 89.136 389.295 88.8177 388.716 88.5631C387.752 88.1811 386.402 87.9902 385.117 88.0538C383.895 88.1175 382.674 88.3721 381.902 88.754C381.838 88.754 381.838 88.8177 381.774 88.8177C381.388 89.0087 381.131 89.2633 380.938 89.5816C380.809 89.7089 380.745 89.8999 380.745 90.1545V99.5757H371.295V97.0294C371.295 96.4565 370.781 96.0109 370.138 96.0109H365.896C365.253 96.0109 364.739 96.4565 364.739 97.0294V99.5757H362.489C361.846 99.5757 361.331 100.021 361.331 100.594V104.223C361.331 104.796 361.846 105.241 362.489 105.241H363.903H365.446H380.938V109.315H365.767C365.767 109.315 365.703 109.315 365.638 109.315C364.996 109.315 364.481 109.761 364.481 110.334V113.962C364.481 114.535 364.996 114.981 365.638 114.981H380.938V120.137V121.537ZM383.188 90.5364C383.638 90.2818 384.474 90.1545 385.309 90.0908C386.274 90.0272 387.174 90.1545 387.816 90.4091C387.945 90.4728 388.009 90.4728 388.074 90.5364V175.719H383.124L383.188 90.5364ZM407.102 101.613V103.204H390.388V101.613H407.102ZM404.595 111.352V112.944H390.388V111.289L404.595 111.352ZM366.796 112.944V111.352H380.938V113.007H366.796V112.944ZM363.839 103.204V101.613H380.938V103.204H363.839ZM369.238 98.7482H367.246V98.0479H369.238V98.7482ZM401.702 98.8755H399.709V98.1753H401.702V98.8755Z",
    fill: "#AABDC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.553 147.383V176.561C353.553 176.88 353.874 177.198 354.26 177.198H358.567C358.953 177.198 359.274 176.943 359.274 176.561V143.436H368.531C368.917 143.436 369.238 143.181 369.238 142.799V140.635C369.238 140.317 368.917 139.999 368.531 139.999H363.002C362.745 140.38 363.26 139.68 363.002 139.999H361.974H359.274V137.58H363.581H364.545H370.074C370.459 137.58 370.781 137.325 370.781 136.943V134.779C370.781 134.46 370.459 134.142 370.074 134.142H367.502V132.678C367.502 132.36 367.181 132.041 366.795 132.041H364.224C363.838 132.041 363.517 132.296 363.517 132.678V134.142H359.274V128.477C359.274 128.349 359.21 128.222 359.145 128.158C358.953 127.904 358.631 127.713 358.31 127.522C357.731 127.267 356.895 127.203 356.124 127.203C355.353 127.203 354.645 127.394 354.196 127.649H354.131C353.938 127.776 353.746 127.904 353.617 128.095C353.553 128.158 353.488 128.286 353.488 128.413V134.078H347.831V132.614C347.831 132.296 347.51 131.978 347.124 131.978H344.553C344.167 131.978 343.846 132.232 343.846 132.614V134.142H342.496C342.11 134.142 341.789 134.397 341.789 134.779V136.943C341.789 137.261 342.11 137.58 342.496 137.58H343.332H344.296H353.553V139.999H344.424H344.36C343.974 139.999 343.653 140.253 343.653 140.635V142.799C343.653 143.118 343.974 143.436 344.36 143.436H353.553V146.555V147.383ZM354.903 128.668C355.16 128.54 355.674 128.413 356.188 128.413C356.767 128.413 357.345 128.477 357.731 128.604C357.795 128.604 357.86 128.668 357.86 128.668V175.718H356.349H354.838L354.903 128.668ZM369.302 135.352V136.306H359.21V135.352H369.302ZM367.824 141.208V142.163H359.274V141.208H367.824ZM345.003 142.163V141.208H353.553V142.163H345.003ZM343.267 136.306V135.352H353.553V136.306H343.267ZM346.481 133.633H345.324V133.251H346.481V133.633ZM366.088 133.696H364.931V133.251H366.088V133.696Z",
    fill: "#AABDC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.969 136.37H343.976C344.619 136.242 345.197 136.115 345.776 135.924C369.111 129.749 367.247 105.241 367.247 105.241H369.24C369.175 105.241 371.168 131.022 345.969 136.37Z",
    fill: "#AABDC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.619 112.939L390.412 112.939L390.412 111.284L404.619 111.284L404.619 112.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.92,
    y: 135.576,
    width: 10.1862,
    height: 1.13179,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.185,
    y: 141.237,
    width: 7.92256,
    height: 1.13179,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.762,
    y: 135.576,
    width: 10.1862,
    height: 1.13179,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.894,
    y: 141.237,
    width: 7.92256,
    height: 1.13179,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2231 179.607V131.218L18.4034 130.037L39.6476 125.316L49.6795 129.447V180.787L41.4179 183.148L18.9935 180.787L17.2231 179.607Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2243 131.218L17.2243 179.017C17.2243 179.017 17.1074 180.943 19.199 180.943L39.6713 183.261C39.6713 183.261 41.5168 183.333 41.3569 181.262V126.392C41.3569 126.392 41.1046 125.316 38.5087 125.316L18.6084 130.142C18.6084 130.142 17.2243 130.142 17.2243 131.218Z",
    fill: "url(#paint1_linear)",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2212 139.417L41.0667 135.443",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.826 125.907L49.6777 129.447V181.378L40.2358 183.148",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.8188 142.052C27.8188 141.567 28.1661 141.153 28.6431 141.067L29.2926 140.951C29.9055 140.842 30.4684 141.313 30.4684 141.936V146.171C30.4684 146.793 29.9055 147.265 29.2926 147.155L28.6431 147.039C28.1661 146.954 27.8188 146.539 27.8188 146.055V142.052Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.051 175.526H337.416L264.819 181.62L201.363 177.91L125.189 179.5L102.801 177.778L98.9592 178.308L74.4512 175.658L69.1521 176.321L47.2936 174.731H6.62354",
    stroke: "#8FA1AC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4124 0.014689C94.5929 -0.118541 93.91 0.68084 94.3197 1.34699L114.397 38.6514L132.016 71.2929C132.29 71.959 132.972 72.3587 133.655 72.3587L265.32 88.746C266.14 88.8792 266.686 87.9466 266.277 87.2805L225.892 25.0352C225.892 25.0352 225.482 24.6355 225.209 24.6355L95.4124 0.014689Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M130.489 6.75061L168.244 76.3004",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M164.932 13.3743L202.688 81.5994",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M197.389 19.3357L235.807 86.8984",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M112.605 33.9083L244.418 54.4421",
    stroke: "white",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 384.842,
    cy: 130.489,
    r: 23.1833,
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M381.368 135.765C381.474 135.741 383.33 139.852 383.714 141.977C383.109 142.971 382.561 143.918 382.088 144.78C382.073 144.806 382.065 144.835 382.063 144.865C382.06 144.895 382.065 144.925 382.075 144.953C382.085 144.981 382.101 145.006 382.122 145.027C382.143 145.048 382.168 145.064 382.195 145.074L383.863 145.71C383.887 145.72 383.914 145.724 383.94 145.724C383.966 145.723 383.992 145.717 384.016 145.705C384.04 145.694 384.062 145.678 384.08 145.658C384.098 145.639 384.112 145.615 384.121 145.59C384.796 143.817 385.601 142.099 386.53 140.45C390.513 141.875 394.734 141.261 397.159 136.963C399.87 132.158 399.125 127.188 402.727 122.918C402.727 122.918 382.827 124.367 384.717 137.66C387.135 133.718 391.155 130.171 394.343 128.77C391.169 131.291 387.844 135.596 385.209 139.612C383.594 135.252 379.615 128.669 376.136 125.331C378.685 126.744 381.754 130.013 383.455 133.489C386.11 122.532 369.608 119.805 369.608 119.805C372.271 123.645 371.246 127.739 373.12 131.959C374.74 135.606 378.041 136.508 381.368 135.765Z",
    fill: "#56A662"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M386.01 112.605C383.29 116.269 380.96 121.967 384.008 126.599C383.894 123.269 384.204 119.964 385.173 117.028C384.621 119.911 384.357 125.719 385.243 129.884C385.356 129.679 385.473 129.476 385.599 129.277C385.727 129.074 385.86 128.877 385.999 128.685C385.961 128.4 385.928 128.067 385.896 127.668C390.927 123.328 386.703 118.177 386.01 112.605Z",
    fill: "#56A662"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.4513,
    y1: 125.316,
    x2: 33.4513,
    y2: 183.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56A662"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 29.2949,
    y1: 125.316,
    x2: 29.2949,
    y2: 183.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84EC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56A662"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 177.518,
    fill: "white",
    transform: "translate(0 7.41284)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSupplyMode);
export default __webpack_public_path__ + "static/media/self-supply-mode.8d4c4132c054a7577949dd866166860a.svg";
export { ForwardRef as ReactComponent };